import {
  Component,
  OnInit,
  ViewChild,
  Input,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';
import { NgbCarousel, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { PhotoCarouselService } from '@shared/services/photo-carousel/photo-carousel.service';

@Component({
  selector: 'photo-carousel',
  templateUrl: './photo-carousel.component.html',
  styleUrls: ['./photo-carousel.component.scss'],
  providers: [NgbCarouselConfig]
})
export class PhotoCarouselComponent implements OnInit, AfterViewInit {
  @ViewChild('imageCarousel')
  imageCarousel: NgbCarousel;

  images = [];
  imageIndex = 0;
  triggerOnSlide = false;
  slideWidth = '100%';
  slideHeight = '100%';
  isForGallery = false;
  minHeight = 'unset';

  @Input()
  set PropertyImages(data) {
    this.images = data || [];
    if (this.images.length > 0 && !this.images[0].hasOwnProperty('slideId')) {
      this.generateSlideIds(this.images);
    }
  }

  @Input()
  set SlideWidth(width) {
    this.slideWidth = width;
  }

  @Input()
  set IsGallery(param) {
    this.isForGallery = param;
    this.minHeight = '';
  }

  @Input()
  set SlideHeight(height) {
    this.slideHeight = height;
  }

  constructor(
    private _photoCarouselService: PhotoCarouselService,
    private ngbCarouselConfig: NgbCarouselConfig
  ) {
    this.isForGallery = false;
    this.ngbCarouselConfig.keyboard = false;
  }

  ngOnInit() {
    this._photoCarouselService.updateImageIndex.subscribe(index => {
      this.imageIndex = index;
      this.updateImage();
    });

    this.imageIndex = this._photoCarouselService.imageIndex;
  }

  ngAfterViewInit() {
    this.updateImage();
  }

  updateImage() {
    this.imageCarousel.select(`img-${this.imageIndex}`);
  }

  arrowSlide(direction) {
    direction === 'left'
      ? this.imageCarousel.prev()
      : this.imageCarousel.next();
    const numImages = this.images.length - 1;
    direction === 'right' ? this.imageIndex++ : this.imageIndex--;
    this.imageIndex = this.imageIndex < 0 ? numImages : this.imageIndex;
    this.imageIndex = this.imageIndex > numImages ? 0 : this.imageIndex;
    if (this.isForGallery) {
      this._photoCarouselService.setImageIndex(this.imageIndex);
    }
  }

  generateSlideIds(images) {
    images.map((image, index) => {
      image.slideId = index;
    });
  }
}
